import { render, staticRenderFns } from "./DashFeed.vue?vue&type=template&id=6f83cb91&"
import script from "./DashFeed.vue?vue&type=script&lang=js&"
export * from "./DashFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports